
const About = () => {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl sm:text-4xl font-bold text-[#1B3A5F] mb-6">
              About <span className="text-[#F5A623]">Finance Planning Wealth</span>
            </h2>
            <p className="text-gray-600 text-base mb-6 leading-relaxed">
              Finance Planning Wealth is dedicated to providing comprehensive financial planning and wealth management services to individuals and businesses. As a new firm, we bring fresh perspectives and innovative approaches to financial planning, combined with deep industry expertise.
            </p>
            <p className="text-gray-600 text-base mb-6 leading-relaxed">
              Our mission is to empower our clients to achieve their financial goals through personalised strategies, expert guidance, and unwavering commitment to their success. We understand that every client's situation is unique, and we take the time to understand your specific needs, goals, and concerns.
            </p>
            <p className="text-gray-600 text-base mb-8 leading-relaxed">
              Whether you're planning for retirement, building wealth, protecting your assets, or managing business finances, we're here to provide the expertise and support you need to make informed decisions and secure your financial future.
            </p>

            <div className="grid grid-cols-2 gap-6 mb-8">
              <div className="bg-gray-50 rounded-lg p-6">
                <div className="w-12 h-12 bg-[#F5A623] rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-user-star-line text-2xl text-white"></i>
                </div>
                <h3 className="text-2xl font-bold text-[#1B3A5F] mb-2">Expert</h3>
                <p className="text-gray-600 text-sm">Professional advisors</p>
              </div>
              <div className="bg-gray-50 rounded-lg p-6">
                <div className="w-12 h-12 bg-[#F5A623] rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-heart-line text-2xl text-white"></i>
                </div>
                <h3 className="text-2xl font-bold text-[#1B3A5F] mb-2">Client-Focused</h3>
                <p className="text-gray-600 text-sm">Your goals matter</p>
              </div>
            </div>

            <button
              onClick={() => {
                const element = document.getElementById('contact');
                if (element) {
                  const offset = 80;
                  const elementPosition = element.getBoundingClientRect().top;
                  const offsetPosition = elementPosition + window.pageYOffset - offset;
                  window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
                }
              }}
              className="bg-[#F5A623] text-white px-8 py-3.5 rounded-lg text-base font-semibold hover:bg-[#E09612] transition-colors shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              Learn More About Us
            </button>
          </div>

          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <div className="w-full h-full">
                <img
                  src="https://static.readdy.ai/image/fbd6e293aff082c6551014a76550a28a/da56f690f035880e1e35688ba9c3ce73.png"
                  alt="Financial Planning Consultation"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
            <div className="absolute -bottom-6 -right-6 bg-[#1B3A5F] rounded-xl p-6 shadow-xl max-w-xs">
              <div className="flex items-center mb-2">
                <h4 className="text-white font-bold text-lg">Helping people make confident financial decisions through trusted professional advice.</h4>
              </div>
              <p className="text-white/80 text-sm">
                Syd Martin - Director
              </p>
            </div>
          </div>
        </div>

        <div className="mt-20 grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="text-center">
            <div className="w-16 h-16 bg-gradient-to-br from-[#F5A623] to-[#E09612] rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-eye-line text-3xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-[#1B3A5F] mb-3">Our Vision</h3>
            <p className="text-gray-600 text-sm leading-relaxed">
              To be the trusted partner for individuals and businesses seeking comprehensive financial planning and wealth management solutions.
            </p>
          </div>
          <div className="text-center">
            <div className="w-16 h-16 bg-gradient-to-br from-[#F5A623] to-[#E09612] rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-compass-line text-3xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-[#1B3A5F] mb-3">Our Mission</h3>
            <p className="text-gray-600 text-sm leading-relaxed">
              To empower our clients with expert guidance, personalised strategies, and unwavering support to achieve their financial goals.
            </p>
          </div>
          <div className="text-center">
            <div className="w-16 h-16 bg-gradient-to-br from-[#F5A623] to-[#E09612] rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-star-line text-3xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-[#1B3A5F] mb-3">Our Values</h3>
            <p className="text-gray-600 text-sm leading-relaxed">
              Integrity, transparency, expertise, and client-focused service are at the core of everything we do.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
